module.exports = require("react-string-replace");


//////////////////
// WEBPACK FOOTER
// external "react-string-replace"
// module id = 16
// module chunks = 0 1 3